import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getResortsAction } from '../../../services/request';
import { ResortList } from './resort/ResortList';
import { CircularProgressContainer } from '../../../components-core/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components-core/others/AlertDialogContainer';

export const ResortRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getResortsAction(search, 'GET'));
  const optionsRequest = useQuery(getResortsAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [resorts, setResorts] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allSeasons, setAllSeasons] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setResorts(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setResorts(
        _.map(resorts, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setResorts(_.filter(resorts, obj => obj.id !== obj2.id));
    } else {
      setResorts([obj2, ...resorts]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Box display="flex" justifyContent="center">
      </Box>
      <ResortList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        resorts={resorts}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        allSeasons={allSeasons} />
    </>
  );
};
